import { useParams, Link, Navigate } from "react-router-dom";
import { ArrowLeft, ArrowUpRight, Check } from "lucide-react";
import { SERVICES } from "../data/site";

export default function ServizioDetail() {
  const { slug } = useParams();
  const service = SERVICES.find((s) => s.slug === slug);

  if (!service) return <Navigate to="/servizi" replace />;

  const otherServices = SERVICES.filter((s) => s.slug !== slug);

  return (
    <>
      <section className="pt-32 md:pt-40 pb-12 bg-[#F5F5F3]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <Link
            to="/servizi"
            className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-neutral-500 hover:text-[#1D4ED8] transition-colors mb-8"
          >
            <ArrowLeft className="w-4 h-4" /> Tutti i servizi
          </Link>
          <div className="overline mb-6">/ {service.number} — Settore</div>
          <h1 className="hero-title text-5xl sm:text-6xl md:text-7xl lg:text-8xl max-w-5xl" data-testid="servizio-detail-title">
            {service.title}
          </h1>
          <p className="mt-8 text-lg md:text-xl text-neutral-700 max-w-3xl leading-relaxed">
            {service.description}
          </p>
        </div>
      </section>

      <section className="relative h-[50vh] md:h-[70vh] bg-[#0B1E3F] overflow-hidden md:rounded-3xl md:mx-6 md:mb-8">
        <img src={service.image} alt={service.title} className="absolute inset-0 w-full h-full object-cover" />
      </section>

      <section data-reveal className="py-20 md:py-28 bg-white border-b border-neutral-200">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-5">
            <div className="overline mb-6">/ Cosa offriamo</div>
            <h2 className="hero-title text-4xl md:text-5xl lg:text-6xl">
              Interventi<br />specifici.
            </h2>
          </div>
          <div className="md:col-span-7 md:pt-6 space-y-[1px] bg-neutral-200 border border-neutral-200">
            {service.offerings.map((item, i) => (
              <div key={i} className="bg-white p-6 md:p-8 flex items-start gap-5 group hover:bg-[#F5F5F3] rounded-2xl border border-neutral-200 transition-colors">
                <div className="w-10 h-10 bg-[#1D4ED8] text-white flex-shrink-0 flex items-center justify-center rounded-xl">
                  <Check className="w-5 h-5" strokeWidth={3} />
                </div>
                <div className="font-display font-bold text-xl md:text-2xl tracking-tight">
                  {item}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section data-reveal className="py-20 md:py-28 bg-[#0B1E3F] text-white relative overflow-hidden">
        <div className="grain" />
        <div className="max-w-[1400px] mx-auto px-6 md:px-10 relative">
          <div className="grid grid-cols-1 md:grid-cols-12 gap-10 items-center">
            <div className="md:col-span-7">
              <div className="overline text-[#60A5FA] mb-6">/ Lavora con noi</div>
              <h2 className="hero-title text-white text-4xl md:text-5xl lg:text-6xl">
                Hai un intervento<br />
                di <span className="text-[#60A5FA]">{service.title.toLowerCase()}</span>?
              </h2>
            </div>
            <div className="md:col-span-5">
              <p className="text-neutral-400 text-lg mb-8">
                Contattaci per un sopralluogo gratuito e un preventivo dettagliato.
              </p>
              <Link
                to="/contatti"
                data-testid="servizio-detail-cta"
                className="inline-flex items-center gap-2 bg-[#1D4ED8] hover:bg-[#1E3A8A] text-white px-7 py-4 rounded-full font-display font-bold text-sm tracking-wider uppercase transition-colors"
              >
                Richiedi preventivo <ArrowUpRight className="w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Altri servizi */}
      <section data-reveal className="py-20 md:py-28 bg-[#F5F5F3]">
        <div className="max-w-[1400px] mx-auto px-6 md:px-10">
          <div className="overline mb-6">/ Continua a esplorare</div>
          <h2 className="hero-title text-4xl md:text-5xl lg:text-6xl mb-16">Altri servizi</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5">
            {otherServices.map((s) => (
              <Link
                key={s.slug}
                to={`/servizi/${s.slug}`}
                className="group bg-white p-8 md:p-10 hover:bg-[#0B1E3F] rounded-2xl border border-neutral-200 hover:text-white transition-colors"
              >
                <div className="flex items-start justify-between mb-10">
                  <div className="font-mono text-xs tracking-[0.25em] text-neutral-500 group-hover:text-[#60A5FA]">
                    / {s.number}
                  </div>
                  <ArrowUpRight className="w-5 h-5 group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform" />
                </div>
                <h3 className="font-display font-black uppercase tracking-tighter text-3xl md:text-4xl mb-4">
                  {s.title}
                </h3>
                <p className="text-neutral-600 group-hover:text-neutral-400">{s.short}</p>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
